export default {
  SET_ITEMS (state, data) {
    state.items = data
  },

  ADD_ITEMS (state, data) {
    state.items = [...state.items, ...data]
  },

  REMOVE_ITEM (state, id) {
    state.items = state.items.filter(function (item) {
      return item.NotificationId !== id
    })
  },

  SET_READ (state, id) {
    const index = state.items.findIndex(item => item.NotificationId === id)
    state.items[index].IsRead = '1'
  },

  SET_ALL_READ (state) {
    state.items.forEach(function (value, index) {
      state.items[index].IsRead = '1'
    })
  },

  EMPTY_ITEMS (state) {
    state.items = []
  },

  SET_PAGINATION (state, payload) {
    state.pagination = {
      page: payload.page || state.pagination.page,
      limit: payload.limit || state.pagination.limit,
      total: payload.total || state.pagination.total
    }
  },

  SET_ERROR (state, data) {
    state.error = data
  },

  SET_LOADING (state, data) {
    state.loading = data
  }
}
